module.exports = __webpack_public_path__ + "img/8cf8a5d.webp";